import { BaseApiService } from '../../../api/base';
import type {
  TrackCampaignRequest,
  TrackCampaignResponse,
} from '../types/campaign';

class CampaignApiService extends BaseApiService {
  async track(request: TrackCampaignRequest): Promise<TrackCampaignResponse> {
    return this.post<TrackCampaignResponse>('/campaign/track', request);
  }
}

export const campaignApiService = new CampaignApiService();
